import React, { useEffect, useState } from 'react';
import { Select, Spin, message } from 'antd';
import debounce from 'lodash/debounce';
import {
  apiGetDevicesInformation,
  apiGetDevicesInformationV2
} from '@services/ManageDevices/DeviceServices';

const { Option } = Select;

const DeviceSelect = ({
  onChange,
  initValue,
  disabled,
  placeholder = 'Lựa chọn thiết bị',
  type
}) => {
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [deviceSelected, setDeviceSelected] = useState(null);

  const fetchDevices = async (searchText, type) => {
    setLoading(true);
    try {
      const response = await apiGetDevicesInformationV2({
        keyWord: searchText ?? undefined,
        status: type == 'NEW' ? 'STORED' : undefined,
        page: 1,
        size: 3000
      });
      setDevices(response.data?.data);
    } catch (error) {
      message.error('Có lỗi khi lấy thông tin thiết bị!');
      console.error('Failed to fetch customers', error);
    }
    setLoading(false);
  };

  const handleSearch = debounce((value) => {
    fetchDevices(value);
  }, 300);

  const handleChange = (value) => {
    setDeviceSelected(value);
    onChange && onChange(value);
  };

  useEffect(() => {
    fetchDevices(null, type);
  }, [type]);

  useEffect(() => {
    if (initValue && devices.length > 0) {
      const deviceFound = devices.find((device) => device.serial_no === initValue);
      if (deviceFound) {
        setDeviceSelected({
          value: deviceFound.serial_no,
          label: `${deviceFound.serial_no} - ${deviceFound.imei}`
        });
      }
    }
  }, [initValue, devices]);

  const renderCustomerOption = (device) => (
    <Option
      key={device.imei}
      value={device.serial_no}
      label={`${device.serial_no}-${device.imei}`}
      title={`${device.model}`}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div>
          <div style={{ fontSize: '14px', fontWeight: '400', color: '#0284c7' }}>
            {`${device.serial_no} - ${device.imei}`}
          </div>
          <div style={{ fontSize: '12px', color: 'var(--muted)', fontWeight: '400' }}>
            {device.model}
          </div>
        </div>
      </div>
    </Option>
  );

  return (
    <Select
      disabled={disabled}
      showSearch
      labelInValue
      placeholder={placeholder}
      onChange={handleChange}
      value={deviceSelected}
      notFoundContent={loading ? <Spin size="small" /> : null}
      filterOption={false}
      onSearch={handleSearch}
      style={{ width: '100%', height: '36px' }}
      optionLabelProp="label">
      {devices.map(renderCustomerOption)}
    </Select>
  );
};

export default DeviceSelect;
